import React from 'react'
import { ArrowUpRight } from 'lucide-react'
import { customerSay } from './customerSayData'

// Amazon-style "Customers say" block: an editorial summary plus theme chips with
// sentiment arrows. Content lives in customerSayData.ts (refreshed weekly). Chips are
// selectable — clicking one filters the reviews list to that theme.
interface CustomerSayProps {
    className?: string
    activeTheme?: string | null
    onSelectTheme?: (label: string | null) => void
}

const CustomerSay: React.FC<CustomerSayProps> = ({ className = '', activeTheme = null, onSelectTheme }) => {
    const { summary, categories } = customerSay

    if (!summary || categories.length === 0) {
        return null
    }

    return (
        <div className={className}>
            <h3 className="font-headline text-[18px] md:text-[20px] tracking-[-0.01em] text-black mb-2">
                Customers say
            </h3>
            <p className="font-body text-[14px] md:text-[15px] leading-[1.6] text-[#3D3D3D]">
                {summary}
            </p>
            <div className="text-[12px] text-[#8A8A8A] mt-1.5">Summarised from customer reviews</div>

            <div className="font-headline text-[12px] uppercase tracking-[0.06em] text-[#8A8A8A] mt-4 mb-2">
                Select to learn more
            </div>
            <div className="flex flex-wrap gap-2">
                {categories.map((cat) => {
                    const active = activeTheme === cat.label
                    return (
                        <button
                            key={cat.label}
                            type="button"
                            onClick={() => onSelectTheme?.(active ? null : cat.label)}
                            aria-pressed={active}
                            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[13px] transition-colors duration-200 ${
                                active
                                    ? 'border-orange bg-orange/10 text-black'
                                    : 'border-[#E9E9E9] bg-white text-[#3D3D3D] hover:border-[#C9C9C9]'
                            }`}
                        >
                            {cat.sentiment === 'positive' ? (
                                <ArrowUpRight className="w-3.5 h-3.5 text-green" strokeWidth={2.5} />
                            ) : (
                                <span className="text-[#8A8A8A] font-headline leading-none">~</span>
                            )}
                            <span className="font-headline text-black">{cat.label}</span>
                            <span className="text-[#8A8A8A]">({cat.count})</span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default CustomerSay
